import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Hidden from '@material-ui/core/Hidden'
import Card from 'atoms/Card'

const styles = theme => ({
  card: {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '100%',
  },
  mobileReplacer: {
    margin: -theme.spacing.unit * 2,
    display: 'inline-block',
    verticalAlign: 'top',
    width: '100%',
  }
})

const DesktopOnlyCard = ({ classes, children, className, ...rest }) => (
  <Fragment>
    <Hidden xsDown>
      <Card
        {...rest}
        className={classNames(className, classes.card)}
      >
        { children }
      </Card>
    </Hidden>

    <Hidden smUp>
      <div className={classes.mobileReplacer}>
        { children }
      </div>
    </Hidden>
  </Fragment>
)

DesktopOnlyCard.propTypes = {
  children: PropTypes.any,
  classes: PropTypes.object.isRequired,
  className: PropTypes.any,
}

export default withStyles(styles)(DesktopOnlyCard)
